import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { setColor } from "../../../../../assets/styles/styles";

const DateFilter = ({ selected, onSelect, setIsDateFilterOpen }) => {
    const options = ["Last 24 hours", "Last 7 days", "Last 30 days", "Last 90 days", "Custom"];
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDateFilterOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [setIsDateFilterOpen]);

    return (
        <DatePickerContainer ref={dropdownRef}>
            {options.map((option) => (
                <DatePickerOption
                    key={option}
                    selected={selected === option}
                    onClick={() => {
                        if (onSelect) onSelect(option);
                        if (setIsDateFilterOpen) setIsDateFilterOpen(false);
                    }}
                >
                    {option}
                </DatePickerOption>
            ))}
        </DatePickerContainer>
    );
};

export default DateFilter;

const DatePickerContainer = styled.div`
    position: absolute;
    top: 100%;
    left: 17%;
    z-index: 10;
    display: flex;
    max-width: 172px;
    min-width: 100px;
    padding: 14px 12px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border-radius: 10px;
    border: 1px solid var(--white-white-20, rgba(255, 255, 255, 0.2));
    background: #110e21;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.25);

    @media (max-width: 768px) {
        width: 100vw;
        min-width: unset;
        padding: 14px 0;
        border-radius: 0 0 10px 10px;
    }
`;

const DatePickerOption = styled.div`
    display: flex;
    padding: 6px 10px;
    justify-content: start;
    align-items: center;
    gap: 10px;
    color: ${(props) => (props.selected ? `${setColor.hightlight}` : `${setColor.inputText}`)};
    align-self: stretch;
    border-radius: ${(props) => (props.selected ? "82px" : "0px")};
    background: ${(props) => (props.selected ? `${setColor.pinkButtonBgGradient}` : "transparent")};
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
        background: ${setColor.iconColor3};
        color: ${setColor.inputBgColor};
    }
`;
